export const ASSIGN_PROCESS_URL = '/assign_to_process';
export const GET_SIDEBAR_MENU_LIST_URL = '/sidebar-menu';